module.exports = __webpack_public_path__ + "static/media/Warning.7ad9a762.svg";